import { useTranslation } from "react-i18next";
import "../spf.scss";
import "./spf-final.scss";
import OprationResult from "../../../auxiliary/opration/opration";
import { Breadcrumb, Button } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { convertToJalaliWithTime, formatMsisdn, formatTime } from "../../../../tools/tools";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { clearGlobalFormData } from "../../../../reducer/serviceReducerGlobala";
import SPFShopLayout from "../spf-shop-layout";

const SPFFinalFactor = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const formData = useSelector((state) => state?.from?.spForeign);
  const dispatch = useDispatch();

  // درفت این درخواست دیگه لازم نیست؛ فقط وقتی از این صفحه خارج شد پاک کن تا خلاصه‌ی همین صفحه درست نمایش داده بشه
  useEffect(() => {
    return () => {
      dispatch(clearFormData(["spForeign"]));
      dispatch(clearGlobalFormData(["spForeign"]));
    };
  }, [dispatch]);

  return (
    <>
      <SPFShopLayout>
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.global.title") }]}
          />
          <div className="title-page">
            <h3>{t("simcardpurchase.global.title")}</h3>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main sp-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="final-container">
                  <div className="row-content-form">
                    <div className="content-area">
                      <OprationResult
                        isSucess={true}
                        list={[
                          {
                            label: "تاریخ و ساعت",
                            value: (
                              <span dir="ltr">
                                {convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
                              </span>
                            ),
                          },
                          {
                            label: "نوع سرویس",
                            value: <>ثبت‌نام سیم‌کارت</>,
                          },
                          {
                            label: "شماره سیم کارت",
                            value: <span dir="ltr">{formatMsisdn(location?.state?.msisdn?.toString())}</span>,
                          },
                          {
                            label: "شماره کیت",
                            value: <span dir="ltr">{formData?.spKit}</span>,
                          },
                          {
                            label: "کد پیگیری",
                            value: <span dir="ltr">{location?.state?.followupcode}</span>,
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button className="btn-normal btn-print" onClick={() => window.print()} type="default" icon={<i className="icon-print"></i>}>
                    چاپ فاکتور
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </SPFShopLayout>
    </>
  );
};

export default SPFFinalFactor;
